import { TAdFoxBannerTemplate } from '@cian/adfox-component';
import { AdFoxTemplates } from '@cian/adfox-templates';
import { Base64 } from 'js-base64';
import * as React from 'react';

import { TgbNativedescGeneralContext } from '../../../../../types/AdfoxBannerContexts';
import { BannerTgbOffer } from '../BannerTgbOffer';

const OWN_BUNDLE_NAMES = ['banner.transfer'];
const OWN_TYPES: TAdFoxTemplatesParams['type'][] = ['tgb_nativedesc_general'];

export type TAdFoxTemplatesParams = TgbNativedescGeneralContext;

export const OwnTemplates: React.FC<TAdFoxBannerTemplate> = props => {
  const { bundleName, bundleParams } = props;

  if (bundleName && OWN_BUNDLE_NAMES.includes(bundleName) && bundleParams) {
    if (bundleName === 'banner.transfer' && bundleParams.htmlBase64) {
      try {
        const decodedParams = Base64.decode(bundleParams.htmlBase64);
        const parsedDecodedParams = JSON.parse(decodedParams);

        if (isParsedParamsValid(parsedDecodedParams)) {
          if (OWN_TYPES.includes(parsedDecodedParams.type)) {
            switch (parsedDecodedParams.type) {
              case 'tgb_nativedesc_general':
                return (
                  <BannerTgbOffer
                    /**
                     * @description Так как данный шаблон используется для показа баннеров как для мобильного веба,
                     * то мы берём изображение для мобильных разрешений, если оно есть.
                     */
                    image={parsedDecodedParams.mobImageUrl || parsedDecodedParams.image}
                    description={parsedDecodedParams.description}
                    url={parsedDecodedParams.url}
                    title={parsedDecodedParams.title}
                    footnote={parsedDecodedParams.annotation}
                    phone={parsedDecodedParams.phone}
                    label={parsedDecodedParams.label}
                  />
                );
            }
          }
        }
      } catch (e) {
        console.error('[AdFox] Failed to decode/parse bundleParams', bundleParams, e);
      }
    }
  }

  return <AdFoxTemplates {...props} />;
};

function isParsedParamsValid(params: object): params is TAdFoxTemplatesParams {
  return 'type' in params;
}
